module.exports = __webpack_public_path__ + "img/start_glossy.acad0ee1.png";